import * as types from "../actions/locationActions";

/* ================================
   INITIAL STATE
================================ */
const initialState = {
  loading: false,          // Shared loader for all location APIs
  districts: [],           // District dropdown
  municipalities: [],      // Municipality dropdown
  wards: [],               // Ward dropdown
  canteenTypes: [],        // Canteen type dropdown
  canteenList: [],         // Filtered canteen result
  error: null,
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {

    /* ===== REQUEST STATES ===== */
    case types.FETCH_DISTRICTS_REQUEST:
    case types.FETCH_MUNICIPALITIES_REQUEST:
    case types.FETCH_WARDS_REQUEST:
    case types.FETCH_CANTEEN_TYPES_REQUEST:
    case types.FETCH_CANTEEN_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    /* ===== SUCCESS STATES ===== */
    case types.FETCH_DISTRICTS_SUCCESS:
      return { ...state, loading: false, districts: action.payload };

    case types.FETCH_MUNICIPALITIES_SUCCESS:
      return { ...state, loading: false, municipalities: action.payload };

    case types.FETCH_WARDS_SUCCESS:
      return { ...state, loading: false, wards: action.payload };

    case types.FETCH_CANTEEN_TYPES_SUCCESS:
      return { ...state, loading: false, canteenTypes: action.payload };

    case types.FETCH_CANTEEN_LIST_SUCCESS:
      return { ...state, loading: false, canteenList: action.payload };

    /* ===== FAILURE STATES ===== */
    case types.FETCH_DISTRICTS_FAILURE:
    case types.FETCH_MUNICIPALITIES_FAILURE:
    case types.FETCH_WARDS_FAILURE:
    case types.FETCH_CANTEEN_TYPES_FAILURE:
    case types.FETCH_CANTEEN_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default locationReducer;
